import { Theme } from "@app/theme";
import { useTheme } from "@shopify/restyle";
import Svg, { Circle, Defs, RadialGradient, Rect, Stop } from "react-native-svg";
const GradientBackground = ()=>{
    const {colors} = useTheme<Theme>();
    return(
        <Svg height="100%" width="100%">
        <Defs>
            <RadialGradient
                id="bottomLeft"
                cx="0%" 
                cy="100%" 
                r="80%"
                gradientUnits="userSpaceOnUse"
            >
                <Stop offset="0%" stopColor={colors['bg-fill-emphasis-secondary'] || "#CCFFE2"} stopOpacity="1" />
                <Stop offset="100%" stopColor={colors['bg-fill-emphasis-secondary'] || "#CCFFE2"} stopOpacity="0" />
            </RadialGradient>

            <RadialGradient
                id="topRight"
                cx="100%" 
                cy="0%" 
                r="80%"
                gradientUnits="userSpaceOnUse"
            >
                <Stop offset="0%" stopColor={colors['bg-fill-emphasis-secondary'] || "#CCFFE2"} stopOpacity="1" />
                <Stop offset="100%" stopColor={colors['bg-fill-emphasis-secondary'] || "#CCFFE2"} stopOpacity="0" />
            </RadialGradient>
        </Defs>

        <Rect width="100%" height="100%" fill={colors['bg-fill-primary'] || "white"} />
        <Rect width="100%" height="100%" fill="url(#bottomLeft)" />
        <Rect width="100%" height="100%" fill="url(#topRight)" />
    </Svg>
    )
}
export default GradientBackground;